import React from 'react';

import { UserAgent } from '@mirinae/js-utils';

import MiniTestSVG from '@mirinae/lessons/assets/images/minitest.svg';
import MiniTestPartySVG from '@mirinae/lessons/assets/images/minitestparty.svg';
import MiniLessonDoneSVG from '@mirinae/lessons/assets/images/minilessondone.svg';
import ConjugationDoneSVG from '@mirinae/lessons/assets/images/conjugationdone.svg';
import LessonDoneSVG from '@mirinae/lessons/assets/images/lessondone.svg';
// import { ReactComponent as CultureIntroSVG } from '@mirinae/lessons/assets/images/cultureintro.svg';
// import { ReactComponent as PracticeIntroSVG } from '@mirinae/lessons/assets/images/practiceintro.svg';
// import { ReactComponent as LessonIntroSVG } from '@mirinae/lessons/assets/images/lessonintro.svg';
// import { ReactComponent as VocabIntroSVG } from '@mirinae/lessons/assets/images/vocabintro.svg';
import StampSVG from '@mirinae/lessons/assets/images/stamp.svg';
import HangulSVG from '@mirinae/lessons/assets/images/hangul.svg';
import VocabIntroDesktopSVG from '@mirinae/lessons/assets/images/vocabintro-desktop.svg';
import VocabIntroMobileSVG from '@mirinae/lessons/assets/images/vocabintro-mobile.svg';
import GrammarIntroDesktopSVG from '@mirinae/lessons/assets/images/grammarintro-desktop.svg';
import GrammarIntroMobileSVG from '@mirinae/lessons/assets/images/grammarintro-mobile.svg';
import PracticeIntroDesktopSVG from '@mirinae/lessons/assets/images/practiceintro-desktop.svg';
import PracticeIntroMobileSVG from '@mirinae/lessons/assets/images/practiceintro-mobile.svg';
import CultureIntroDesktopSVG from '@mirinae/lessons/assets/images/cultureintro-desktop.svg';
import CultureIntroMobileSVG from '@mirinae/lessons/assets/images/cultureintro-mobile.svg';
import IdiomIntroDesktopSVG from '@mirinae/lessons/assets/images/idiomintro-desktop.svg';
import IdiomIntroMobileSVG from '@mirinae/lessons/assets/images/idiomintro-mobile.svg';

import euDropsSVG from '@mirinae/lessons/assets/images/eu-drops.svg';
import sieutIrregularSVG from '@mirinae/lessons/assets/images/sieut-irregular.svg';
import hieutIrregularSVG from '@mirinae/lessons/assets/images/hieut-irregular.svg';
import digeutIrregularSVG from '@mirinae/lessons/assets/images/digeut-irregular.svg';
import bieubIrregularSVG from '@mirinae/lessons/assets/images/bieub-irregular.svg';
import rieulIrregularSVG from '@mirinae/lessons/assets/images/rieul-irregular.svg';

import Element from './elements/Element';

export const irregularIcons = {
    'ㅡ drops': euDropsSVG,
    'ㅅ irregular': sieutIrregularSVG,
    'ㄹ irregular': rieulIrregularSVG,
    'ㅂ irregular': bieubIrregularSVG,
    'ㄷ irregular': digeutIrregularSVG,
    'ㅎ irregular': hieutIrregularSVG,
};

const { os } = UserAgent;

const svgStyle = (el) => (os.isOthers ? { height: el.geom.height, width: el.geom.width } : { height: el.mobile.geom.height, width: el.mobile.geom.width });

const graphicComponents = {
    miniTest: ({ element }) => <Element element={element}><object data={MiniTestSVG} style={svgStyle(element)}>Mini-test</object></Element>,
    miniTestParty: ({ element }) => <Element element={element}><object data={MiniTestPartySVG} style={svgStyle(element)}>Mini-test party</object></Element>,
    miniLessonDone: ({ element }) => <Element element={element}><object data={MiniLessonDoneSVG} style={svgStyle(element)}>Mini-lesson done</object></Element>,
    irregularLessonDone: ({ element }) => <Element element={element}><object data={ConjugationDoneSVG} style={svgStyle(element)}>Conjugation done</object></Element>,
    lessonDone: ({ element }) => <Element element={element}><object data={LessonDoneSVG} style={svgStyle(element)}>Lesson done</object></Element>,
    stamp: ({ element }) => <Element element={element}><object style={svgStyle(element)} data={StampSVG} type="image/svg+xml">stamp</object></Element>,
    hangul: ({ element }) => <Element element={element}><object style={svgStyle(element)} data={HangulSVG} type="image/svg+xml">stamp</object></Element>,
    cultureIntro: ({ element }) => <Element element={element}><object data={os.isOthers ? CultureIntroDesktopSVG : CultureIntroMobileSVG} type="image/svg+xml">practice</object></Element>,
    practiceIntro: ({ element }) => <Element element={element}><object data={os.isOthers ? PracticeIntroDesktopSVG : PracticeIntroMobileSVG} type="image/svg+xml">practice</object></Element>,
    lessonIntro: ({ element }) => <Element element={element}><object data={os.isOthers ? GrammarIntroDesktopSVG : GrammarIntroMobileSVG}>Grammar intro</object></Element>,
    vocabIntro: ({ element }) => <Element element={element}><object data={os.isOthers ? VocabIntroDesktopSVG : VocabIntroMobileSVG}>Vocab intro</object></Element>,
    irregularIcon: ({ element }) => (
        <Element element={element}><img alt="no icon selected" src={irregularIcons[element.fieldsByName.icon.value]} width={70} height={70} /></Element>
    ),
    idiomIntro: ({ element }) => <Element element={element}><object data={os.isOthers ? IdiomIntroDesktopSVG : IdiomIntroMobileSVG} type="image.svg+xml">Idiom intro</object></Element>,
};

export default graphicComponents;
